import type { ComponentType } from 'react';

function isComponentLike(value: unknown): value is ComponentType<any> {
  if (typeof value === 'function') {
    return true;
  }
  if (!value || typeof value !== 'object') {
    return false;
  }
  return '$$typeof' in (value as Record<string, unknown>);
}

function isPascalCase(name: string): boolean {
  return /^[A-Z]/.test(name);
}

export function resolveLazyModuleDefault<T extends ComponentType<any>>(
  loadedModule: unknown,
): { default: T } | null {
  if (!loadedModule || typeof loadedModule !== 'object') {
    return null;
  }

  const moduleRecord = loadedModule as Record<string, unknown>;
  const defaultExport = moduleRecord.default;
  if (isComponentLike(defaultExport)) {
    return { default: defaultExport as T };
  }

  const namedCandidates = Object.entries(moduleRecord).filter(
    ([exportName, exportValue]) => exportName !== 'default' && isComponentLike(exportValue),
  );
  if (namedCandidates.length === 0) {
    return null;
  }

  const preferredCandidate = namedCandidates.find(([exportName]) => isPascalCase(exportName));
  if (!preferredCandidate) {
    return null;
  }

  return { default: preferredCandidate[1] as T };
}
